import { render } from "./rate.vue?vue&type=template&id=0d876d29&scoped=true"
import script from "./rate.vue?vue&type=script&lang=js"
export * from "./rate.vue?vue&type=script&lang=js"

import "./rate.vue?vue&type=style&index=0&id=0d876d29&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d876d29"],['__file',"src/views/vab/form/rate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0d876d29"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0d876d29', __exports__)) {
    console.log('reload')
    api.reload('0d876d29', __exports__)
  }
  
  module.hot.accept("./rate.vue?vue&type=template&id=0d876d29&scoped=true", () => {
    console.log('re-render')
    api.rerender('0d876d29', render)
  })

}


export default __exports__